export default __webpack_public_path__ + "static/media/netina-mission.397b73b7.png";